module.exports = __webpack_public_path__ + "dc665582d6a0b8f5f71e4922259988ff.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/humble-bundle-logo.png
// module id = 386
// module chunks = 0